import { NewDynamicTab } from "../../../components/Page";
import { CgsTitle } from "../components";
import { ChhattisgarhDefaultDates } from "../../../config/DefaultDates";
import DemandRealtime from "./DemandRealtime";
import GenerationRealtime from "./GenerationRealtime";
import SummaryRealtime from "./SummaryRealtime";
import { TabSwitcher } from "../CGS_Dashboard";

export function CgsRealtime() {
  return (
    <>
      <NewDynamicTab
        defaultDates={ChhattisgarhDefaultDates}
        header="Real Time"
        headerPrefixComponent={<TabSwitcher />}
        middleComponent={<CgsTitle />}
        disableDatePicker={true}
        tabs={{
          Demand: <DemandRealtime />,
          Generation: <GenerationRealtime />,
          Summary: <SummaryRealtime />,
        }}
      />
    </>
  );
}
